import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";

import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Mission } from "@/components/site/Mission";
import { WhatWeCreate } from "@/components/site/WhatWeCreate";
import { Participate } from "@/components/site/Participate";
import { Vision } from "@/components/site/Vision";
import { Newsletter } from "@/components/site/Newsletter";
import { JoinTheTeam } from "@/components/site/JoinTheTeam";
import { Footer } from "@/components/site/Footer";

const Home = () => {
    const [applyOpen, setApplyOpen] = useState(false);

    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.1,
            smoothWheel: true,
            lerp: 0.1,
        });
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
        return () => lenis.destroy();
    }, []);

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div data-testid="home-page" className="bg-tip-white text-tip-black">
            <Header />
            <main>
                <Hero
                    onParticipate={() => setApplyOpen(true)}
                />
                <Mission />
                <WhatWeCreate onContribute={() => setApplyOpen(true)} />
                <Participate open={applyOpen} onOpenChange={setApplyOpen} />
                <Vision />
                <JoinTheTeam />
                <Newsletter />
            </main>
            <Footer />
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        borderRadius: 0,
                        border: "1px solid #0a0a0a",
                        background: "#0a0a0a",
                        color: "#fafafa",
                        fontFamily: "Satoshi, sans-serif",
                    },
                }}
            />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
